import { type ChirpStaticEnvironments } from '@chewy/chirp-media-kit';
import { type Env } from '@chewy/chat-library-common';

export const CHIRP_ENV: Record<Env, ChirpStaticEnvironments> = {
  prd: 'PRD',
  dev: 'DEV',
  stg: 'STG',
  qat: 'QAT',
};

export const toChirpEnv = (env?: Env): ChirpStaticEnvironments  => {
  return CHIRP_ENV[env ?? 'prd'];
}
